import React, { useState, useEffect } from 'react';
import api from '../api';

var SCENARIO_LABELS = {
  position_move: 'תזוזת מיקום (עלייה/ירידה ב-N)',
  crossed_page1: 'חציית עמוד ראשון',
  dropped_from_1: 'ירידה ממקום 1',
  site_wide_percent: 'סף אתר (% מהמילים)',
};
var PRIORITY_LABELS = { important: 'חשוב', normal: 'רגיל' };
var DIRECTION_LABELS = { down: 'ירידה', up: 'עלייה', any: 'שינוי כלשהו' };
var EDGE_LABELS = { left: 'יציאה מעמוד 1', entered: 'כניסה לעמוד 1', any: 'כל חצייה' };
var COMPARE_LABELS = { yesterday: 'מול אתמול', last_week: 'מול לפני שבוע' };
var PRIORITY_FILTER = { '': 'הכל', low: 'נמוך+', medium: 'בינוני+', high: 'גבוה בלבד' };

var SCENARIO_DEFAULTS = {
  position_move: { direction: 'down', threshold: 5 },
  crossed_page1: { edge: 'left' },
  dropped_from_1: {},
  site_wide_percent: { min_percent: 10, min_words: 3, move_threshold: 2 },
};

function blankRule() {
  return {
    name: '', scenario_type: 'position_move', priority: 'normal', compare_to: 'yesterday',
    params: { direction: 'down', threshold: 5 }, filters: {}, enabled: true,
  };
}

function sel(value, options, onChange) {
  return React.createElement('select', {
    value: value, onChange: function(e) { onChange(e.target.value); },
    style: { padding: '5px 8px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', fontSize: '13px', fontFamily: 'inherit' },
  }, Object.keys(options).map(function(k) { return React.createElement('option', { key: k, value: k }, options[k]); }));
}

function num(value, onChange, placeholder) {
  return React.createElement('input', {
    type: 'number', value: (value === undefined || value === null) ? '' : value, placeholder: placeholder || '',
    onChange: function(e) { onChange(e.target.value === '' ? '' : Number(e.target.value)); },
    style: { width: '80px', padding: '5px 8px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', fontSize: '13px', fontFamily: 'inherit' },
  });
}

function field(label, control) {
  return React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' } },
    React.createElement('span', { style: { fontSize: '12px', color: 'var(--text-secondary)', minWidth: '90px' } }, label),
    control
  );
}

export default function AlertRulesSettings() {
  var _r = useState([]), rules = _r[0], setRules = _r[1];
  var _l = useState(true), loading = _l[0], setLoading = _l[1];
  var _m = useState(null), message = _m[0], setMessage = _m[1];
  var _d = useState(null), draft = _d[0], setDraft = _d[1];
  var _sv = useState(false), saving = _sv[0], setSaving = _sv[1];
  var _sn = useState(false), sending = _sn[0], setSending = _sn[1];

  useEffect(function() { load(); }, []);
  function flash(type, text) { setMessage({ type: type, text: text }); setTimeout(function() { setMessage(null); }, 3000); }

  function load() {
    api.getAlertRules().then(function(d) { setRules(d.rules || []); setLoading(false); })
      .catch(function(e) { console.error(e); setLoading(false); });
  }

  function toggle(rule) {
    api.updateAlertRule(rule.id, { enabled: !rule.enabled }).then(load)
      .catch(function(e) { flash('error', 'שגיאה: ' + e.message); });
  }

  function setF(f, v) { setDraft(function(p) { var n = Object.assign({}, p); n[f] = v; return n; }); }
  function setParam(k, v) { setDraft(function(p) { var n = Object.assign({}, p); n.params = Object.assign({}, p.params); n.params[k] = v; return n; }); }
  function setFilter(k, v) {
    setDraft(function(p) {
      var n = Object.assign({}, p); n.filters = Object.assign({}, p.filters);
      if (v === '' || v === null || v === false) { delete n.filters[k]; } else { n.filters[k] = v; }
      return n;
    });
  }
  function changeScenario(st) {
    setDraft(function(p) { var n = Object.assign({}, p); n.scenario_type = st; n.params = Object.assign({}, SCENARIO_DEFAULTS[st] || {}); return n; });
  }

  function save() {
    if (!draft.name.trim()) { flash('error', 'חסר שם לכלל'); return; }
    setSaving(true);
    var payload = {
      name: draft.name, scenario_type: draft.scenario_type, enabled: draft.enabled,
      priority: draft.priority, params: draft.params || {}, filters: draft.filters || {}, compare_to: draft.compare_to,
    };
    var p = draft.id ? api.updateAlertRule(draft.id, payload) : api.createAlertRule(payload);
    p.then(function() { setSaving(false); setDraft(null); load(); flash('success', 'הכלל נשמר'); })
      .catch(function(e) { setSaving(false); flash('error', 'שגיאה: ' + e.message); });
  }

  function remove(rule) {
    if (!window.confirm('למחוק את הכלל "' + rule.name + '"?')) return;
    api.deleteAlertRule(rule.id).then(function() { load(); flash('success', 'נמחק'); })
      .catch(function(e) { flash('error', 'שגיאה: ' + e.message); });
  }

  function sendTest() {
    setSending(true);
    api.runAlertRules().then(function() { setSending(false); flash('success', 'בדיקת ההתראות נשלחה לנמענים'); })
      .catch(function(e) { setSending(false); flash('error', 'שגיאה: ' + e.message); });
  }

  if (loading) return React.createElement('div', { style: { padding: '20px', color: 'var(--text-muted)', fontSize: '13px' } }, 'טוען התראות...');

  return React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '14px' } },
    // Header
    React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' } },
      React.createElement('div', null,
        React.createElement('div', { style: { fontSize: '15px', fontWeight: 700 } }, 'התראות מיקומים'),
        React.createElement('div', { style: { fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' } }, 'כללי התראה יומיים. נשלח לנמענים של הסיכום השבועי.')
      ),
      React.createElement('div', { style: { display: 'flex', gap: '8px' } },
        React.createElement('button', {
          onClick: sendTest, disabled: sending,
          style: { padding: '6px 14px', background: 'var(--surface)', color: 'var(--accent)', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', fontWeight: 600, cursor: sending ? 'wait' : 'pointer', fontFamily: 'var(--sans)' },
        }, sending ? 'שולח...' : 'שלח בדיקה עכשיו'),
        React.createElement('button', {
          onClick: function() { setDraft(blankRule()); },
          style: { padding: '6px 14px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--sans)' },
        }, '+ כלל חדש')
      )
    ),
    message ? React.createElement('div', {
      style: { padding: '8px 14px', borderRadius: '6px', fontSize: '12px', background: message.type === 'success' ? 'var(--green-glow)' : 'var(--red-glow)', color: message.type === 'success' ? 'var(--green)' : 'var(--red)', border: '1px solid ' + (message.type === 'success' ? 'var(--green)' : 'var(--red)') },
    }, message.text) : null,

    // Editor (add/edit)
    draft ? renderEditor() : null,

    // Rules list
    React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '6px' } },
      rules.length === 0 ? React.createElement('div', { style: { fontSize: '12px', color: 'var(--text-muted)', padding: '8px' } }, 'אין כללים. הוסף כלל חדש.') :
      rules.map(function(rule) {
        return React.createElement('div', { key: rule.id, style: { display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', borderRadius: '8px', border: '1px solid var(--border)', background: rule.enabled ? 'var(--surface)' : 'var(--bg)', opacity: rule.enabled ? 1 : 0.6 } },
          React.createElement('input', { type: 'checkbox', checked: !!rule.enabled, onChange: function() { toggle(rule); }, style: { cursor: 'pointer' }, title: rule.enabled ? 'פעיל' : 'כבוי' }),
          React.createElement('div', { style: { flex: 1 } },
            React.createElement('div', { style: { fontSize: '13px', fontWeight: 600 } }, rule.name),
            React.createElement('div', { style: { fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px' } }, (SCENARIO_LABELS[rule.scenario_type] || rule.scenario_type) + ' · ' + (COMPARE_LABELS[rule.compare_to] || rule.compare_to))
          ),
          React.createElement('span', { style: { fontSize: '10px', padding: '2px 8px', borderRadius: '10px', fontWeight: 600, background: rule.priority === 'important' ? 'var(--red-glow)' : 'var(--surface-hover)', color: rule.priority === 'important' ? 'var(--red)' : 'var(--text-secondary)' } }, PRIORITY_LABELS[rule.priority] || rule.priority),
          React.createElement('button', { onClick: function() { setDraft(JSON.parse(JSON.stringify(rule))); }, style: { padding: '3px 10px', fontSize: '11px', cursor: 'pointer', background: 'var(--surface-hover)', border: '1px solid var(--border)', borderRadius: '4px', color: 'var(--text-secondary)', fontFamily: 'var(--sans)' } }, 'ערוך'),
          React.createElement('button', { onClick: function() { remove(rule); }, style: { padding: '3px 10px', fontSize: '11px', cursor: 'pointer', background: 'none', border: '1px solid var(--border)', borderRadius: '4px', color: 'var(--red)', fontFamily: 'var(--sans)' } }, 'מחק')
        );
      })
    )
  );

  function renderEditor() {
    var st = draft.scenario_type;
    var paramControls = [];
    if (st === 'position_move') {
      paramControls.push(field('כיוון', sel(draft.params.direction || 'down', DIRECTION_LABELS, function(v) { setParam('direction', v); })));
      paramControls.push(field('סף מיקומים', num(draft.params.threshold, function(v) { setParam('threshold', v); }, '5')));
    } else if (st === 'crossed_page1') {
      paramControls.push(field('סוג חצייה', sel(draft.params.edge || 'left', EDGE_LABELS, function(v) { setParam('edge', v); })));
    } else if (st === 'dropped_from_1') {
      paramControls.push(React.createElement('div', { style: { fontSize: '12px', color: 'var(--text-muted)' } }, 'אין פרמטרים נוספים.'));
    } else if (st === 'site_wide_percent') {
      paramControls.push(field('% מינימלי', num(draft.params.min_percent, function(v) { setParam('min_percent', v); }, '10')));
      paramControls.push(field('מינ׳ מילים', num(draft.params.min_words, function(v) { setParam('min_words', v); }, '3')));
      paramControls.push(field('ירידת מיקומים', num(draft.params.move_threshold, function(v) { setParam('move_threshold', v); }, '2')));
    }

    return React.createElement('div', { style: { padding: '14px', borderRadius: '8px', border: '1px solid var(--accent)', background: 'var(--bg)', display: 'flex', flexDirection: 'column', gap: '10px' } },
      React.createElement('div', { style: { fontSize: '13px', fontWeight: 700 } }, draft.id ? 'עריכת כלל' : 'כלל חדש'),
      field('שם', React.createElement('input', { type: 'text', value: draft.name, onChange: function(e) { setF('name', e.target.value); }, style: { flex: 1, minWidth: '200px', padding: '5px 8px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', fontSize: '13px', fontFamily: 'inherit' } })),
      field('סנריו', sel(draft.scenario_type, SCENARIO_LABELS, changeScenario)),
      field('השוואה', sel(draft.compare_to, COMPARE_LABELS, function(v) { setF('compare_to', v); })),
      field('עדיפות', sel(draft.priority, PRIORITY_LABELS, function(v) { setF('priority', v); })),
      React.createElement('div', { style: { height: '1px', background: 'var(--border)', margin: '2px 0' } }),
      React.createElement('div', { style: { fontSize: '12px', fontWeight: 600, color: 'var(--text-secondary)' } }, 'תנאי הסנריו'),
      React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: '8px' } }, paramControls),
      React.createElement('div', { style: { height: '1px', background: 'var(--border)', margin: '2px 0' } }),
      React.createElement('div', { style: { fontSize: '12px', fontWeight: 600, color: 'var(--text-secondary)' } }, 'פילטרים (אופציונלי)'),
      field('נפח חיפוש מינ׳', num(draft.filters.min_search_volume, function(v) { setFilter('min_search_volume', v); }, 'ללא')),
      field('עדיפות מילה', sel(draft.filters.min_priority || '', PRIORITY_FILTER, function(v) { setFilter('min_priority', v); })),
      React.createElement('label', { style: { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: 'var(--text-secondary)', cursor: 'pointer' } },
        React.createElement('input', { type: 'checkbox', checked: !!draft.filters.starred, onChange: function(e) { setFilter('starred', e.target.checked); }, style: { cursor: 'pointer' } }),
        'רק מילים מסומנות בכוכב'
      ),
      React.createElement('div', { style: { display: 'flex', gap: '8px', marginTop: '4px' } },
        React.createElement('button', { onClick: save, disabled: saving, style: { padding: '6px 16px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 600, cursor: saving ? 'wait' : 'pointer', fontFamily: 'var(--sans)' } }, saving ? 'שומר...' : 'שמור'),
        React.createElement('button', { onClick: function() { setDraft(null); }, style: { padding: '6px 16px', background: 'var(--surface)', color: 'var(--text-secondary)', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontFamily: 'var(--sans)' } }, 'ביטול')
      )
    );
  }
}
